import { all, takeLatest, call, fork, put, select, take } from "redux-saga/effects";
import { messages, success, deleteData } from "../../components/messageBox";
import * as types from "../../constants/actionTypes";
import moment from "moment";
import Config from "../../service/Config";
import Endpoint from "../../service/Endpoint";
import { GET, POST } from "../../service/api";
import { Header } from "../../constants/headers";

const getStateModuleLayanan = (state) => state.ModuleLayanan;

export function* getDataLayanan(params) {
  try {
    yield put({ type: types.MODULE_LAYANAN_SET_LOADER, value: true });
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;

    if (params.value == "all") {
      const response = yield call(GET, Config.BASE_URL + Endpoint.MODULE_LAYANAN_LIST_GET + _id);

      if (response.acknowledge == 1) {
        yield put({ type: types.MODULE_LAYANAN_DATA_GET_ALL_SUCCESS, value: response.data });
      } else {
        messages("Error", "Gagal memuat data", "error", false, false);
      }
    } else if (params.value >= 0) {
      const response = yield call(GET, Config.BASE_URL + Endpoint.MODULE_LAYANAN_DETAIL_GET + params.value);
      if (response.acknowledge == 1) {
        const _data = response.data;
        const _formDetail = {
          f_id_layanan: _data.f_id_layanan,
          f_nama_layanan: _data.f_nama_layanan,
          f_tarif_layanan: _data.f_tarif_layanan,
          f_status_administrasi: _data.f_status_administrasi == 1 ? true : false,
          f_tarif_administrasi: _data.f_tarif_administrasi,
          f_catatan: _data.f_catatan,
          f_id_klinik: _data.f_id_klinik,
          f_id_poli: _data.f_id_poli,
          f_status_catatan: _data.f_status_catatan == 1 ? true : false,
        };

        yield put({ type: types.MODULE_LAYANAN_DATA_GET_DETAIL_SUCCESS, value: _formDetail });
      } else {
        messages("Error", "Gagal memuat data", "error", false, false);
      }
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }
    yield put({ type: types.MODULE_LAYANAN_SET_LOADER, value: false });
  } catch (error) {
    yield put({ type: types.MODULE_LAYANAN_SET_LOADER, value: false });
    messages("Error", error, "error", false, false);
  }
}

export function* getMasterData() {
  try {
    yield put({ type: types.MODULE_LAYANAN_SET_LOADER, value: true });
    let _body = {
      MasterData: [
        {
          ObjectName: "listPoli",
          id: JSON.parse(localStorage.getItem("UserData")).f_id_klinik,
        },
      ],
    };
    const response = yield call(POST, Config.BASE_URL + Endpoint.GET_LIST_MASTER_DATA, _body);
    yield all(yield put({ type: types.MODULE_LAYANAN_MASTER_DATA_SUCCESS, property: "listPoli", value: response.data.listPoli }));

    yield put({ type: types.MODULE_LAYANAN_SET_LOADER, value: false });
  } catch (error) {
    yield put({ type: types.MODULE_LAYANAN_SET_LOADER, value: false });
    messages("Error", error, "error", false, false);
  }
}

export function* postForm(params) {
  try {
    yield put({ type: types.MODULE_LAYANAN_SET_LOADER, value: true });

    let stateModuleLayanan = yield select(getStateModuleLayanan);
    const _data = stateModuleLayanan.formLayanan;
    const _body = {
      f_id_layanan: _data.f_id_layanan,
      f_nama_layanan: _data.f_nama_layanan,
      f_tarif_layanan: _data.f_tarif_layanan,
      f_status_administrasi: _data.f_status_administrasi == true ? 1 : 0,
      f_tarif_administrasi: _data.f_status_administrasi ? _data.f_tarif_administrasi : null,
      f_status_catatan: _data.f_status_catatan == true ? 1 : 0,
      f_catatan: _data.f_status_catatan ? _data.f_catatan : null,
      f_id_klinik: JSON.parse(localStorage.getItem("UserData")).f_id_klinik,
      f_id_poli: _data.f_id_poli,
    };

    if (!params.value) {
      const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_LAYANAN_CREATE_POST, _body, { headers: Header() });
      if (response.acknowledge == 1) {
        yield put({ type: types.MODULE_LAYANAN_SET_LOADER, value: false });
        messages("Berhasil", response.message, "success", false, params.history);
      } else {
        messages("Error", response.message, "error", false, false);
      }
    } else {
      const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_LAYANAN_UPDATE_POST, _body, { headers: Header() });
      if (response.acknowledge == 1) {
        messages("Berhasil", response.message, "success", false, params.history);
      } else {
        messages("Error", response.message, "error", false, false);
      }
    }

    yield put({ type: types.MODULE_LAYANAN_SET_LOADER, value: false });
  } catch (error) {
    yield put({ type: types.MODULE_LAYANAN_SET_LOADER, value: false });
    messages("Error", error, "error", false, false);
  }
}

export default function* rootSaga() {
  yield all([takeLatest(types.MODULE_LAYANAN_DATA_GET, getDataLayanan), takeLatest(types.MODULE_LAYANAN_MASTER_DATA, getMasterData), takeLatest(types.MODULE_LAYANAN_SUBMIT_FORM, postForm)]);
}
